import { updateItems } from '@motillo/avarda-checkout/Client/lib/AvardaCheckout.action';
import { updateQuantity } from '../Services/Cart.service';
import { get, post, put } from '../Services/http';
import { catchError } from './Error.action';

export const CART_LOAD = 'CART_LOAD';
export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';
export const CART_HIDE = 'CART_HIDE';
export const SHOULD_SHOW_ERROR_MESSAGE = 'SHOULD_SHOW_ERROR_MESSAGE';

var loadCartAbortController = new AbortController();
export const load = () => (dispatch, getState) => {
    if (loadCartAbortController) {
        loadCartAbortController.abort();
        loadCartAbortController = new AbortController();
    }
    return get('/api/cart', loadCartAbortController)
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
};

export const loadError = error => ({
    type: CART_LOAD_ERROR,
    payload: {
        error,
    }
});

export const receive = cart => ({
    type: CART_RECEIVE,
    payload: cart,
});

export const toggle = () => (dispatch, getState) => {
    dispatch(show(!getState().cart.showInfo));
};

export const shouldShowErrorMessage = (shouldShowErrorMessage) => ({
    type: SHOULD_SHOW_ERROR_MESSAGE,
    payload: {
        addedTooManyProducts: shouldShowErrorMessage
    }
})

export const showMiniCart = () => ({
    type: CART_SHOW_INFO,
    payload: {
        visible: true,
        shouldClose: false
    }
});

export const closeMiniCart = () => ({
    type: CART_SHOW_INFO,
    payload: {
        shouldClose: true
    }
});


export const setMiniCartVisible = visible => ({
    type: CART_SHOW_INFO,
    payload: {
        visible,
    }
});

const show = visible => ({
    type: CART_SHOW_INFO,
    payload: {
        visible,
    }
});

export const setShippingCost = (shippingCost) => ({
    type: CART_RECEIVE,
    payload: {
        shippingCost
    }
})

export const update = (rowSystemId, quantity, abortController = null, refreshAvarda = false) => async (dispatch) => {
    try {
        if (window._sw) {
            window._sw((api) => api.suspend());
        }

        const cart = await updateQuantity(rowSystemId, quantity, abortController);
        dispatch(receive(cart));
        if (refreshAvarda && cart && cart.orderRows && cart.orderRows.length > 0) {
            dispatch(updateItems());
        }
    } catch (ex) {
        dispatch(catchError(ex, error => loadError(error)));
    }
}